import React from 'react';
import PropTypes from 'prop-types';
import { strings } from '../../../localization';
import ProgressOverlay from '../../../components/common/ProgressOverlay';

export default class FlagFilterDropDown extends React.PureComponent {

    static propTypes = {
        optionsWithClickState: PropTypes.array.isRequired, // clickState: ( 2: excluded (false), 1: included (true), 0: blank (can be true or false) )
        onChangeClickState: PropTypes.func.isRequired,
    }

    constructor(props) {
        super(props);
        this.state = {
            expanded: false,
        };

        this.mouseLeaveTimeout = undefined;
        this.containerElement = React.createRef();
    }

    componentDidMount() {
        document.addEventListener("mousedown", this.onClickOutsideContainer);
    }

    componentWillUnmount() {
        document.removeEventListener("mousedown", this.onClickOutsideContainer);
    }

    handleCheckBoxClick = (index) => {
        this.props.onChangeClickState(index);
    }

    onClickOutsideContainer = (event) => {
        if (this.containerElement && !this.containerElement.current.contains(event.target)) {
            clearTimeout(this.mouseLeaveTimeout);
            this.setState({ expanded: false });
        }
    }

    toggleDropdown = () => {
        this.setState((prevState) => ({
            expanded: !prevState.expanded,
        }));
    };

    render() {
        const { expanded } = this.state;
        const { optionsWithClickState } = this.props;

        const numberSelectedFlags = optionsWithClickState.filter(option => option.clickState === 1).length;

        return (
            <div className="flag-filter-field">
                <form className="form-common"
                    ref={this.containerElemnent}
                    onMouseLeave={() => {
                        this.mouseLeaveTimeout = setTimeout(() => {
                            this.setState({ expanded: false })
                        }, 900);
                    }}
                    onMouseEnter={() => { clearTimeout(this.mouseLeaveTimeout) }}
                >
                    <div className={`flag-dropdown ${expanded ? "expanded" : ""}`} ref={this.containerElement}>
                        <div className="flag-select-box">
                            <div className="input-container">
                                    <input
                                        className="flag-input"
                                        type="text"
                                        readOnly
                                        placeholder={numberSelectedFlags > 0 ? (strings.reports_filter_flag + ": " + strings.formatString(strings.reports_header_selected_flags, numberSelectedFlags)) : strings.reports_header_include_or_exclude_flags}
                                        onClick={this.toggleDropdown}
                                    />
                                    <i className="material-icons">keyboard_arrow_down</i>
                                </div>
                        </div>
                            <div className="flag-checkboxes" style={{ display: expanded ? "block" : "none" }} >
                                <div className="description-font">{strings.reports_header_include_or_exclude_flags_description}</div>
                                {optionsWithClickState.map((option, index) => (
                                    <label htmlFor={option.value} key={index} 
                                        className={`checkbox-row ${
                                            option.clickState === 1
                                            ? "row-included"
                                            : option.clickState === 2
                                            ? "row-excluded"
                                            : ""
                                        }`
                                    }>
                                        <span className="custom-checkbox-wrapper">
                                            <input
                                                type="checkbox"
                                                id={option.value}
                                                className="custom-checkbox"
                                                readOnly
                                                checked={option.clickState === 1 || option.clickState === 2} // checked if state is included or excluded
                                                onChange={() => {}} // no action on change
                                                onClick={() => {this.handleCheckBoxClick(index)}} // checkbox change are handled by onClick not the default onChange
                                                disabled={this.props.loadingFlag === option.value}
                                            />
                                            <span 
                                                className={`custom-checkbox-indicator ${
                                                            option.clickState === 1
                                                            ? "state-checked"
                                                            : option.clickState === 2
                                                            ? "state-crossed"
                                                            : ""
                                                        }`}
                                            />
                                        </span>
                                        <span className="custom-label">{option.label}</span>
                                    </label>
                                ))}
                            </div>
                    </div>

                </form>
            </div>
        );
    }
}